
import Vue, { PropType } from 'vue'
import { IProduct } from 'types/DTO/products'
import { IMetaData } from 'types/DTO/common/response'
import { IPreaparyty, IAnalogs } from 'types/DTO/trade'

export default Vue.extend({
  name: 'RPHAnalogs',
  components: {
    RPHProductCard: () => import('rph/molecules/RPHProductCard/index.vue'),
    RPHProductSort: () => import('rph/molecules/RPHProductSort/index.vue'),
    RPHPagination: () => import('rph/molecules/RPHPagination/index.vue'),
    EmptyProducts: () => import('~/components/atoms/EmptyProducts.vue'),
    FilterIcon: () => import('~/assets/icons/filter-icon.svg?inline'),
    RPHFilterModal: () => import('~/components/v2/organisms/RPHFilterModal/index.vue'),
  },
  props: {
    data: {
      type: Object,
    },
    products: {
      type: Array as PropType<IProduct[]>,
      default: () => [],
    },
    meta: {
      type: Object as PropType<IMetaData>,
      default: () => {},
    },
  },
  data() {
    return {
      filterVisible: false,
    }
  },
  computed: {
    titleNumber() {
      return this.$route.query.page && this.$route.query.page !== '1'
        ? `- страница ${this.$route.query.page}`
        : ''
    },

    seoText(): String {
      const seoText = this.$props.data.seo_text
      return seoText && (this.$route.query.page === '1' || !this.$route.query.page) ? seoText : ''
    },
  },

  methods: {
    setFilterOnMobile() {
      this.filterVisible = !this.filterVisible
    },
  },
})
